import { render, staticRenderFns } from "./ConsultarFolio.vue?vue&type=template&id=c5eea42a&"
import script from "./ConsultarFolio.vue?vue&type=script&lang=ts&"
export * from "./ConsultarFolio.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports